import React, { useState } from 'react';
import styled from 'styled-components';

const PeriodRow = styled.div`
  display:flex;align-items:center;padding:10px 12px;
  margin-left:${p => p.$indent}px;
  cursor:${p => p.$hasKids ? 'pointer' : 'default'};
  border-left:3px solid ${p => p.$current ? p.theme.colors.bands.exceptional : 'transparent'};
  background:${p => p.$current ? '#fffde7' : 'transparent'};
  font-weight:${p => p.$current ? p.theme.typography.weights.semibold : p.theme.typography.weights.regular};
  border-bottom:1px solid ${p => p.theme.colors.background};min-height:44px;
  &:hover{background:${p => p.$current ? '#fffde7' : p.theme.colors.background};}
`;
const Icon = styled.span`flex:0 0 20px;font-size:${p => p.theme.typography.sizes.xs};color:${p => p.theme.colors.text.muted};`;
const Lord = styled.span`flex:0 0 80px;font-weight:${p => p.theme.typography.weights.medium};`;
const Dates = styled.span`flex:1;font-size:${p => p.theme.typography.sizes.sm};color:${p => p.theme.colors.text.secondary};`;
const Dur = styled.span`flex:0 0 90px;text-align:right;font-size:${p => p.theme.typography.sizes.sm};color:${p => p.theme.colors.text.muted};`;

const fmtDuration = (p) => {
  if (p.display_duration) return p.display_duration;
  const dp = p.duration_parts;
  if (!dp) return p.years ? `${p.years}y` : '';
  const parts = [];
  if (dp.years) parts.push(`${dp.years}Y`);
  if (dp.months) parts.push(`${dp.months}M`);
  if (dp.days) parts.push(`${dp.days}D`);
  return parts.join(' ') || '0';
};

function renderLevel(periods, level, parentKey, maxLevels, highlight, expanded, toggleFn) {
  if (level > maxLevels || !periods?.length) return null;
  const indent = (level - 1) * 20;
  const childField = level === 1 ? 'antardashas' : 'pratyantdashas';

  return periods.map((p, i) => {
    const key = `${parentKey}-${i}`;
    const hasKids = p[childField]?.length > 0 && level < maxLevels;
    const isExp = expanded.has(key);
    const isCur = highlight && p.is_current;

    return (
      <React.Fragment key={key}>
        <PeriodRow $indent={indent} $current={isCur} $hasKids={hasKids}
                   onClick={hasKids ? () => toggleFn(key) : undefined}>
          <Icon>{hasKids ? (isExp ? '▼' : '▶') : ' '}</Icon>
          <Lord>{p.lord}</Lord>
          <Dates>{p.start_date} — {p.end_date}</Dates>
          <Dur>{fmtDuration(p)}</Dur>
        </PeriodRow>
        {hasKids && isExp &&
          renderLevel(p[childField], level + 1, key, maxLevels, highlight, expanded, toggleFn)}
      </React.Fragment>
    );
  });
}

export default function DashaTimeline({ periods, levels = 3, highlightCurrent = true }) {
  const [expanded, setExpanded] = useState(() => {
    const init = new Set();
    periods?.forEach((p, i) => { if (p.is_current) init.add(`L1-${i}`); });
    return init;
  });

  const toggle = (key) => setExpanded(prev => {
    const next = new Set(prev);
    next.has(key) ? next.delete(key) : next.add(key);
    return next;
  });

  return <div>{renderLevel(periods, 1, 'L1', levels, highlightCurrent, expanded, toggle)}</div>;
}
